export default __webpack_public_path__ + "static/services2-592c173e8dc854dd1550668abb9d1f2f.png";